<template>
    <div class="panel panel-info">
		<div class="panel-heading"><h4 class="panel-title"><i class="fa fa-book"></i>直播详情</h4></div>
        <div class="panel-body" >
            <div class="row">
				<div class="col-sm-12 text-center">
					<h1>{{infKc.kcdm}}-{{infKc.kcmc}}</h1>
					<h5 class="text-success"><em>(直播时间：{{kczbInfo.kssj}}-{{kczbInfo.jssj}})</em></h5>
				</div>
                <div class="col-sm-12" style="padding-top: 10px">
					<a role="button" class="btn btn-success btn-sm" href="https://jxjy-att.whxunw.com/guotu_att/zbclients/%E8%AE%AF%E7%BD%91%E7%9B%B4%E6%92%AD%E5%AE%A2%E6%88%B7%E7%AB%AF%28%E7%BB%A7%E7%BB%AD%E6%95%99%E8%82%B2%E6%AD%A3%E5%BC%8F%E7%89%88%292020-1126-03-01Setup.exe" style="margin-bottom: 3px;"><i class="fa fa-download" aria-hidden="true"></i>点击下载直播客户端</a>
					<BootstrapTable style="font-size: 14px;"
                                    ref="table"
                                    v-once
                                    :columns="columns"
                                    :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:false,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
                                    @onPostBody="vueFormatterPostBody"
									@onClickRow="clickRow"
                    />
                </div>
                <a id="xunw_zb_client_open_link" style="position: absolute;top: -99999;left: -99999;display: none;"><button class="open_btn">go</button></a>
            </div>
        </div>
		<ZbTldz ref="ZbTldz"></ZbTldz>
		<ZbBfdz ref="ZbBfdz"></ZbBfdz>
		<ZbXxzlAdd ref="ZbXxzlAdd"></ZbXxzlAdd>
		<ZhiboTjhfAdd ref="ZhiboTjhfAdd"></ZhiboTjhfAdd>
    </div>
</template>
<script>

    /**
     * 直播管理-直播详情列表
     */
    import tableMixin from '@/mixins/table.js';  //表格
    import ZbTldz from './ZbTldz.vue';//推流地址
    import ZbBfdz from './ZbBfdz.vue';//播放地址
    import ZbXxzlAdd from './ZbXxzlAdd.vue';//直播学校资料
	import ZhiboTjhfAdd from './ZhiboTjhfAdd.vue';//直播添加回放

    export default {
        mixins: [tableMixin],
        name:"ZhiboDetailList",
        components :{
			ZbTldz,
			ZbBfdz,
			ZbXxzlAdd,
			ZhiboTjhfAdd
        },
        data:function(){
            return {
                js:this.$store.state.user.js,
                zbList:[],
				infKc:{},
				kczbInfo:{},
                query:{
					id:this.$route.query.kczbId
                },
                columns: [
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center',
                        formatter: (value, row, index)=> {
                            var options = this.$refs.table.getOptions();
                            return options.pageSize * (options.pageNumber - 1) + index + 1;
                        }
                    },
                    {
                        field: 'lessonName',
                        title: '章节名称'
                    },

                    {
                        field: 'zbbt',
                        title: '标题'
                    },
                    {
                        field: 'jsmc',
                        title: '讲师'
                    },
                    {
                        field: 'ljgkrs',
                        title: '累积观看人数'
                    },
                    {
                        field: 'kssj',
                        title: '开始时间',

                    },
                    {
                        field: 'jssj',
                        title: '结束时间',

                    },
                    {
                        field: 'zbtlzta',
                        title: '文档流状态',
                        formatter: (value, row) => {
                            return value=='WORKING'?'<span class="text-success">推流中...</span>':'<span class="text-danger">断流</span>';
                        }
                    },
                    {
                        field: 'zbtlztb',
                        title: '教师流状态',
                        formatter: (value, row) => {
                            return value=='WORKING'?'<span class="text-success">推流中...</span>':'<span class="text-danger">断流</span>';
                        }
                    },
                    {
                        field: 'zbzt',
                        title: '直播状态',
                        formatter: (value, row) => {
                            let p = {
                                'READY':'未开始',
                                'PLAYING':'正在直播',
                                'FINISHED':'已结束'
                            }
                            let status = p[value] || '';
                            if(value == 'FINISHED'){
                                if(row.duration){
                                    status += '<span class="text-success">(时长：'+row.duration+'分钟)<span>';
                                }
                                else{
                                    status += '<span class="text-info">(回放视频生成中...)<span>';
                                }
                            }
                            return status;
                        }
                    },
                    {
                        field: 'actions',
                        title: '操作',
                        align: 'center',
                        formatter: (value, row) => {
                            let html="";
                            if(row.zbzt != 'FINISHED'){
                                html += '<a @click="kszb(row)">开始直播</a> | ';
                            }
                            html += '<a @click="zbxc(row)">直播现场</a> | ';
                            if(row.zbzt != 'FINISHED'){
                                html += '<a @click="jszb(row)">结束直播</a> | ';
                            }
                            if(row.zbzt == 'FINISHED' && row.duration){
                                html += '<a @click="zbff(row)">回放</a> | ';
                            }
                            if(this.js !== 'ZYPX_JIANGSHI'){
                                html += '<a @click="tldz(row)">推流地址</a> | ';
                                html += '<a @click="bfdz(row)">播放地址</a> | ';
                            }

                            html += '<a @click="xxzl(row)">学习资料</a>';
							if(row.zbzt != 'FINISHED'){
							    html += '<a @click="tjhf(row)"> | 添加回放</a>';
							}
                            return this.vueFormatter({
                                template: '<div class="operation_column">'
                                    +html
                                    +'</div>',
                                data: { row },
                                methods: {
                                    editKt: this.editKt,
                                    kszb: this.kszb,
                                    jszb: this.jszb,
                                    tldz: this.tldz,
                                    xxzl: this.xxzl,
                                    bfdz: this.bfdz,
                                    zbff:this.zbff,
                                    zbxc: this.zbxc,
									tjhf:this.tjhf
                                }
                            })
                        }
                    }
                ]
            }
        },
        mounted(){
            this.load();
        },
        created:function(){
            this.$store.commit('setBreadcrumb',[{name:'职业培训'},{name:'在线培训'},{name:'直播管理'},{name:'直播列表'},{name:'直播详情列表'}]);
			this.$store.commit('setShowReturnBackBtn',true);
        },
        methods: {
            zbff:function(row){
                this.$router.push({name:'ZhiboPlayBack',query:{id:row.id}});
            },
            //推流地址
            tldz:function(row){
				this.$refs.ZbTldz.open({zbId:row.id});
            },
            //播放地址
            bfdz:function(row){
				this.$refs.ZbBfdz.open({zbId:row.id});
            },
            //学习资料
            xxzl:function(row){
				this.$refs.ZbXxzlAdd.open({ zbId:row.id});
            },

			// 添加回放
			tjhf:function(row){
			    this.$refs.ZhiboTjhfAdd.open({zbId:row.id});
			},

            //直播现场
            zbxc:function(row){
                this.$router.push({name:'ZhiboXianchang',query:{id:row.id}});
            },
            //修改课堂
            editKt:function(row){
                this.$router.push({name:'ZhiboEdit',query:{id:row.id}});
            },
            search:function(){
                //将数据表格的页码以及每一页展示的数据重置为1，10
                this.$refs.table.refreshOptions({pageNumber:1, pageSize:10});
                this.load(1,10);
            },
            kszb:function(row){
                let url = 'XunwLiveClientC://liveId=' + row.id;
                $("#xunw_zb_client_open_link").attr('href',url);
                this.$confirm('请您检查本机是否已经安装直播客户端，如果没有安装，请点击上方的直播客户端下载链接进行下载安装，如果您确定已经安装直播客户端请继续',()=>{
                    $("#xunw_zb_client_open_link").show();
                    $("#xunw_zb_client_open_link").find('.open_btn').trigger('click');
                    $("#xunw_zb_client_open_link").hide();
                });
            },
            jszb:function(row){
                this.$confirm('确定结束直播吗？',()=>{
                    this.$http.post('/htgl/biz/zypx/zb/jszb',{id:row.id}).then(res=>{
                        if(res.data){
                            this.$success('操作成功',()=>{
                                this.load();
                            })
                        }
                    });
                });
            },
            load:function(){
                this.$http.post('/htgl/biz/zypx/zb/getKczbById',this.query).then(res=>{
                    let data = res.data;
					this.kczbInfo = res.data;
					console.log('-data:',res.data);
					let zbList = res.data.zbList || [];
					this.infKc = res.data.infKc;
					this.$refs.table.load(zbList);
                });
            }
        }

    }
</script>
<style scoped>

</style>
